import { createContext } from 'react';
import { DialogContextProps } from './interfaces/DialogContextProps';

export const DialogContext = createContext<DialogContextProps>(
  {} as DialogContextProps
);
